module.exports = __webpack_public_path__ + "img/lietuvaskaito-original-1920.7328ca20.png";